import CSupercoreProgressBar from './Index.vue';
export default CSupercoreProgressBar;
